(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vo-handwraps-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vo-handwraps-showcase')) {
    customElements.define('vo-handwraps-showcase', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('.vo-wraps__track');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-index]')];
        if (!this.track || !this.slides.length) return;
        this.index = 0;
        const update = () => {
          this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / this.track.clientWidth)));
          this.querySelector('[data-counter]').textContent = `${this.index + 1} / ${this.slides.length}`;
          this.dots.forEach((dot, index) => {
            if (index === this.index) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        };
        this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => this.go(this.index + Number(button.dataset.direction)), {signal}));
        this.dots.forEach(dot => dot.addEventListener('click', () => this.go(Number(dot.dataset.index)), {signal}));
        this.track.addEventListener('scroll', update, {passive: true, signal});
        this.track.addEventListener('keydown', event => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, {signal});
        this.resizeObserver = new ResizeObserver(() => this.go(this.index, true));
        this.resizeObserver.observe(this.track);
        update();
      }
      go(index, instant = false) {
        const next = (index + this.slides.length) % this.slides.length;
        this.track.scrollTo({left: next * this.track.clientWidth, behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vo-legal-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-vo-cookie-preferences]');
    if (!trigger) return;

    if (window.privacyBanner?.showPreferences) {
      window.privacyBanner.showPreferences();
      return;
    }

    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.2' }],
        () => window.privacyBanner?.showPreferences?.()
      );
    }
  });

  } catch(e) { console.error(e); }
})();
})();
